import { callApi } from "./api.service";

export const GetStripeConnectAccountDetails = async (
  getToken: () => Promise<string | null>
) => {
  const endpoint = `/api/stripe/connect/get-account-details`;
  return await callApi(endpoint, "GET", true, getToken);
};

export const CreateStripeConnectAccount = async (
  getToken: () => Promise<string | null>
) => {
  const endpoint = "/api/stripe/connect/account";
  return await callApi(endpoint, "POST", true, getToken, {
    country: "US",
    returnBackUrl: window.location.href,
  });
};

export const GetStripeDashboardLink = async (
  getToken: () => Promise<string | null>
) => {
  const endpoint = `/api/stripe/connect/get-dashboard-login-link`;
  return await callApi(endpoint, "GET", true, getToken);
};

export const UpdatePopupShow = async (
  getToken: () => Promise<string | null>
) => {
  const endpoint = `/api/stripe/connect/update-is-popup-show`;
  return await callApi(endpoint, "POST", true, getToken);
};
